<template>
  <div class="container">
    <div class="production-container">
      <div class="production-section">
        <el-form
          label-position="right"
          label-width="100px"
          :model="editForm"
          ref="editForm"
          :rules="rules"
        >
          <div class="production_data-section">
            <p class="header-title">上传学生作品</p>
            <div class="production_data-section-body">
              <div class="link">
                <el-form-item label="诗名" prop="poetry_name">
                  <el-input
                    size="mini"
                    v-model="editForm.poetry_name"
                  ></el-input>
                </el-form-item>
                <el-form-item label="作者姓名" prop="author">
                  <el-input size="mini" v-model="editForm.author"></el-input>
                </el-form-item>
              </div>
              <div class="link">
                <el-form-item
                  label="学校"
                  prop="school_name"
                  :show-message="false"
                >
                  <el-input
                    size="mini"
                    v-model="editForm.school_name"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item label="指导教师" prop="teacher_name">
                  <el-input
                    size="mini"
                    v-model="editForm.teacher_name"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="link">
                <el-form-item label="年龄" prop="age">
                  <el-input
                    size="mini"
                    v-model.number="editForm.age"
                  ></el-input>
                </el-form-item>
                <el-form-item label="当前班级" prop="classroom_id">
                  <el-select
                    size="mini"
                    v-model="editForm.classroom_id"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in gradeData"
                      :key="item.id"
                      :label="item.class_name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="link">
                <el-form-item label="作品所属季节" prop="season_id">
                  <el-select
                    size="mini"
                    v-model="editForm.season_id"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in seasonData"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="production_content-section">
            <p class="production_content-section_header header-title">诗主题</p>
            <div class="production_content-section_content">
              <el-form-item prop="poetry_content">
                <quill-editor
                  class="quill-editor"
                  v-model="editForm.poetry_content"
                  ref="myQuillEditor"
                >
                </quill-editor>
              </el-form-item>
            </div>
          </div>
          <div class="production_image-section">
            <p class="production_image-section_header header-title">上传作品</p>
            <el-form-item prop="image_url">
              <el-upload
                action=""
                class="avatar-uploader"
                :show-file-list="false"
                :http-request="uploadImage"
                :before-upload="beforeAvatarUpload"
              >
                <img
                  v-if="editForm.image_url"
                  :src="editForm.image_url"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </div>
        </el-form>
        <div class="production_save-section">
          <el-button @click="goback" size="medium">返回</el-button>
          <el-button @click="handleSubmit" size="medium">保存</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import userService from "@/global/service/user";
import ossService from "@/global/service/oss";
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"],
  ["blockquote", "code-block"],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ direction: "rtl" }],
  [{ size: ["small", false, "large", "huge"] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }],
  [{ font: [] }],
  [{ align: [] }],
  ["clean"],
  ["link", "image", "video"]
];
export default {
  data() {
    return {
      rules: {
        age: [
          { required: true, message: "请输入年龄", trigger: "blur" },
          { type: "number", message: "年龄必须为数字值" }
        ],
        poetry_name: [
          { required: true, message: "请输入诗名", trigger: "change" }
        ],
        author: [
          { required: true, message: "请输入作者名", trigger: "change" }
        ],
        teacher_name: [
          { required: true, message: "请填写老师名称", trigger: "blur" }
        ],
        school_name: [{ required: true }],
        classroom_id: [
          { required: true, message: "请选择当前年级", trigger: "blur" }
        ],
        season_id: [
          { required: true, message: "请选择作品季节", trigger: "blur" }
        ],
        poetry_content: [
          { required: true, message: "请填写诗主题", trigger: "blur" }
        ],
        image_url: [{ required: true, message: "请上传作品", trigger: "blur" }]
      },
      schoolData: [],
      seasonData: [
        { id: 1, name: "春" },
        { id: 2, name: "夏" },
        { id: 3, name: "秋" },
        { id: 4, name: "冬" }
      ],
      gradeData: [],
      editForm: {
        age: null,
        author: null,
        classroom_id: null,
        image_url: null,
        poetry_content: null,
        poetry_name: null,
        school_name: null,
        season_id: null,
        teacher_name: null,
        works_id: null
      },
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions
          }
        }
      }
    };
  },
  components: {
    "quill-editor": quillEditor
  },
  created() {
    this.getData();
    Promise.all([userService.classList()]).then(res => {
      this.editForm.school_name = res[0].school.name;
      this.gradeData = res[0].classrooms;
    });
  },
  methods: {
    handleSubmit() {
      let id = this.$route.params.id;
      const params = {
        poetry_name: this.editForm.poetry_name,
        author: this.editForm.author,
        age: this.editForm.age,
        teacher_name: this.editForm.teacher_name,
        classroom_id: this.editForm.classroom_id,
        season_id: this.editForm.season_id,
        poetry_content: this.editForm.poetry_content,
        file_id: this.editForm.file_id
      };
      userService.studentWorkEdit(id, params).then(() => {
        this.$message.success("保存成功");
        this.$router.push({
          name: "my_student_production"
        });
      });
    },
    goback() {
      this.$router.push({
        name: "my_student_production"
      });
    },
    uploadImage(file) {
      this.uploading = true;
      ossService
        .upload({ file }, () => {})
        .then(res => {
          this.editForm.image_url = res.path;
          this.editForm.file_id = res.id;
        })
        .finally(() => {
          this.uploading = false;
        });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    getData() {
      let id = this.$route.params.id;
      userService.studentWorkDetail(id).then(res => {
        this.editForm = {
          age: Number(res.age),
          author: res.author,
          classroom_id: Number((res.classroom || {}).id) || "",
          image_url: (res.file || {}).file_src,
          poetry_content: res.poetry_content,
          poetry_name: res.poetry_name,
          season_id: res.season.id,
          teacher_name: res.teacher_name,
          works_id: res.id,
          file_id: (res.file || {}).id
        };
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-form-item__label {
  font-size: 12px !important;
}
/deep/ .el-select,
.el-select--minit {
  width: 100%;
}
/deep/.ql-toolbar.ql-snow .ql-formats {
  margin: 0;
}
/deep/.production_content-section .el-form-item__content {
  margin: 0 !important;
}
/deep/.production_image-section .el-form-item__content {
  margin: 0 !important;
}
/deep/ .ql-picker-label {
  display: flex;
  align-items: center;
}
.container {
  background-color: #fff;
  padding: 20px;
  .production_data-section-body {
    .link {
      display: flex;
      justify-content: space-between;
      width: 100%;
      .el-form-item {
        width: 48%;
      }
    }
  }
  .production_content-section {
    .production_content-section_content {
      width: 100%;
      /deep/ .ql-editor {
        height: 200px;
      }
    }
  }
}
.header-title {
  width: 100%;
  text-align: left;
  border-bottom: 1px solid #dedede;
  font-size: 12px;
  color: #999;
  line-height: 30px;
  margin-bottom: 20px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
</style>
